import IAmount from "@/module/main/dto/financing-v1/IAmount";
import IFinancingSettings from "@/module/main/dto/financing-v1/IFinancingSettings";

export default class FinancingSettings implements IFinancingSettings {

    constructor(public preferredInstallment: IAmount | undefined,
                public preferredDownPayment: IAmount | undefined,
                public productCode: string,
                public productSetCode: string) {
    }
}
